const enum MessageType {
    ERROR = 'Error',
    WARNING = 'Warning',
    INFO = 'Info',
    SUCCESS = 'Success'
}

export default MessageType;
